module.exports = __webpack_public_path__ + "static/media/floor-1.0221b70e.png";